<!-- @format -->
<ng-container *transloco="let t">
  <ng-container *ngIf="gradeRaiseAttemptCourseUnit$ | async as data">
    <sis-study-notification-box
      type="approved"
      [tertiaryButtonText]="t(getOpenDialogTranslationKeyWhenCompletionMethodSelected(data))"
      (tertiaryClickAction)="openSelectCompletionMethodModal()">
      {{ t("PLAN.GRADE_RAISE_COMPLETION_METHOD_CHOSEN", { completion_method_index: getCompletionMethodIndex(data) }) }}
    </sis-study-notification-box>
  </ng-container>
</ng-container>
